import { getGlobalProperty } from "@faire/globals/deprecated/getGlobalProperty";

export const isRobot = (): boolean => getGlobalProperty("isRobot", false);
